import React from 'react';
import CustomerModifyTreeView from '../../views/customer/modify-tree';
import { CustomerCollection, LocationCollection } from '../../services/collection';

class CustomerModifyTreeScreen extends React.Component {

  state = {
    open: [],
    customer: null,
    location: null
  };

  onToggleOpen = uuid => this.setState(({ open: base }) => {
    const open = base.slice(),
      index = open.findIndex(value => value === uuid);
    if (index === -1) {
      open.push(uuid);
    } else {
      open.splice(index, 1);
    }
    return {
      open
    }
  });

  onSelectCustomer = (unused, customer) => this.onCustomerChange(customer);

  onSelectLocation = (unused, location) => this.onLocationChange(location);

  onCustomerChange = customer => this.setState({
    customer,
    location: null
  });

  onLocationChange = location =>  this.setState({
    customer: null,
    location
  });

  onSave = async () => {
    if (!this.isValid()) {
      return null;
    }
    const { customer, location } = this.state;
    await new Promise(resolve => this.setState({
      disabled: true
    }, resolve));
    const collection = customer ? CustomerCollection : LocationCollection;
    try {
      await collection.actions.save(customer || location);
      await new Promise(resolve => this.setState({
        disabled: false,
        customer: null,
        location: null
      }, resolve));
    } catch(e) {
      console.warn(e);
      alert(`Failed to save ${customer ? 'customer' : 'location'}`);
      await new Promise(resolve => this.setState({
        disabled: false
      }, resolve));
    }
  };

  onCancel = () => this.setState({
    customer: null,
    location: null
  });

  isValid() {
    const { customer, location } = this.state;
    if (!(customer || location)) {
      return false;
    }
    const {
      name,
      regulatoryLicense,
      parentUuid,
      address
    } = (customer || location);
    if (location && !parentUuid) {
      return false;
    }
    if (!address) {
      return false;
    }
    const {
      line1,
      state,
      city,
      country,
      zip
    } = address;
    return !!(
      name &&
      regulatoryLicense &&
      line1 &&
      state &&
      city &&
      country &&
      zip &&
      name.length >= 4 &&
      regulatoryLicense.length >= 4 &&
      line1.length >= 4 &&
      city.length >= 4 &&
      zip.length >= 5 &&
      name.length <= 255 &&
      regulatoryLicense.length <= 255 &&
      line1.length <= 255 &&
      city.length <= 255 &&
      zip.length <= 255
    );
  }

  onCreateCustomer = () => this.onCustomerChange({});

  onCreateLocation = () => {
    const { customer } = this.state;
    return this.onLocationChange({
      parentUuid: customer ? customer.uuid : null
    });
  };

  render() {
    const { onToggleOpen, onSelectCustomer, onSelectLocation, onCustomerChange, onLocationChange, onSave, onCancel, onCreateCustomer, onCreateLocation } = this;
    const { open, customer, location, disabled } = this.state;
    const { customers = [], locations = [], loading } = this.props;
    return (
      <CustomerModifyTreeView
        onToggleOpen={onToggleOpen}
        open={open}
        customer={customer}
        location={location}
        onSelectCustomer={onSelectCustomer}
        onSelectLocation={onSelectLocation}
        onCustomerChange={onCustomerChange}
        onLocationChange={onLocationChange}
        onSave={onSave}
        onCancel={onCancel}
        canSave={!loading && this.isValid()}
        onCreateCustomer={onCreateCustomer}
        onCreateLocation={onCreateLocation}
        canCreateLocation={!!(customer && customer.uuid)}
        customers={customers}
        locations={locations}
        disabled={disabled || !!loading}
      />
    )

  }

}


const mapCustomerProps = ({ loading, list }) => ({ customers: list, customersLoading: loading });
const mapLocationProps = ({ loading, list }) => ({ locations: list, locationsLoading: loading });

const customerConnect = CustomerCollection.connect(mapCustomerProps);
const locationConnect = LocationCollection.connect(mapLocationProps);

export default customerConnect(
  locationConnect(
    CustomerModifyTreeScreen
  )
);


// WEBPACK FOOTER //
// ./src/app/customer/index.js